/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountDelegationsInfo,
    AccountDelegationsInfoFromJSON,
    AccountDelegationsInfoFromJSONTyped,
    AccountDelegationsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountDelegationsResponse
 */
export interface AccountDelegationsResponse {
    /**
     * 
     * @type {Array<AccountDelegationsInfo>}
     * @memberof AccountDelegationsResponse
     */
    list: Array<AccountDelegationsInfo>;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsResponse
     */
    totalSize?: number;
}

export function AccountDelegationsResponseFromJSON(json: any): AccountDelegationsResponse {
    return AccountDelegationsResponseFromJSONTyped(json, false);
}

export function AccountDelegationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDelegationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AccountDelegationsInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function AccountDelegationsResponseToJSON(value?: AccountDelegationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AccountDelegationsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


